import { Database } from 'types/supabase'
import { supabaseClient } from 'supabase'
import { uploadImage } from 'supabase/files'

export type CreateAdvertiserParams = {
  name: Database['public']['Tables']['advertisers']['Row']['name']
  category: Database['public']['Tables']['advertisers']['Row']['category']
  contact_email: Database['public']['Tables']['advertisers']['Row']['contact_email']
  contact_phone?: Database['public']['Tables']['advertisers']['Row']['contact_phone']
  whatsapp?: Database['public']['Tables']['advertisers']['Row']['whatsapp']
  website?: Database['public']['Tables']['advertisers']['Row']['website']
  instagram?: Database['public']['Tables']['advertisers']['Row']['instagram']
  logo_file?: File
}

export const createAdvertiser = async ({
  name,
  category,
  contact_email,
  contact_phone,
  whatsapp,
  website,
  instagram,
  logo_file,
}: CreateAdvertiserParams) => {
  const newAdvertiser = {
    name,
    category,
    contact_email,
    contact_phone,
    whatsapp,
    website,
    instagram,
  }

  const { error, data } = await supabaseClient
    .from('advertisers')
    .insert(newAdvertiser)
    .select()

  if (error) {
    throw error
  }

  let logoUrl = null

  if (logo_file) {
    logoUrl = await uploadImage(
      logo_file,
      `${Date.now()}.${logo_file.type.split('/')[1]}`,
      'advertisers',
      data[0].id
    )

    const { error: updateError } = await supabaseClient
      .from('advertisers')
      .update({ logo_url: logoUrl })
      .eq('id', data[0].id)

    if (updateError) {
      throw updateError
    }
  }

  return {
    id: data[0].id,
    name: data[0].name,
    logo_url: logoUrl || data[0].logo_url
  }
}